import OverlayBg from '../../../../../assets/img/overlay_bg_form.png'

const Screen = () => {
    return (
		<>
            <div className="_row _push_b_g _fmc_hide_mobile _no_print">
                <div className="_fmc_overlay_bg_hide" style={{paddingLeft: 10, paddingRight: 40}}>
                    <img style={{width: 400}} src={OverlayBg}/>
                </div>
                <div className="_column">
                    <div className="_heading_bold _push_b_l" style={{maxWidth: 500}}>
                        Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                    </div>
                    <div className="_relative _push_b_d">
                        <p style={{color: '#888', fontSize: 13}}>
                            Design Eksklusif Oleh
                        </p>
                        <p style={{color: '#444', fontSize: 16}}>
                            Andika Chamberlin
                        </p>
                        <p style={{color: '#888', fontSize: 13, marginTop: 10}}>
                            Didukung Oleh
                        </p>
                        <p style={{color: '#444', fontSize: 16}}>
                            Flamecore Cloud
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Screen;